import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface SovLineFinancials {
  sov_line_id: string;
  estimated_revenue: number;
  estimated_cost: number;
  estimated_margin_pct: number;
  committed_labor: number;
  committed_material: number;
  committed_cost: number;
  committed_margin_pct: number;
  actual_cost: number;
  actual_margin_pct: number;
  cost_variance: number;
  margin_variance: number;
  override_exposure: number;
  has_override: boolean;
}

export const useSovLineFinancials = (contractId: string | undefined) => {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ["sov_line_financials", contractId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_sov_line_financials", {
        p_contract_id: contractId!,
      } as any);
      if (error) throw error;
      const map = new Map<string, SovLineFinancials>();
      (data as any[])?.forEach((row: any) => {
        map.set(row.sov_line_id, {
          sov_line_id: row.sov_line_id,
          estimated_revenue: Number(row.estimated_revenue ?? 0),
          estimated_cost: Number(row.estimated_cost ?? 0),
          estimated_margin_pct: Number(row.estimated_margin_pct ?? 0),
          committed_labor: Number(row.committed_labor ?? 0),
          committed_material: Number(row.committed_material ?? 0),
          committed_cost: Number(row.committed_cost ?? 0),
          committed_margin_pct: Number(row.committed_margin_pct ?? 0),
          actual_cost: Number(row.actual_cost ?? 0),
          actual_margin_pct: Number(row.actual_margin_pct ?? 0),
          cost_variance: Number(row.cost_variance ?? 0),
          margin_variance: Number(row.margin_variance ?? 0),
          override_exposure: Number(row.override_exposure ?? 0),
          has_override: Boolean(row.has_override),
        });
      });
      return map;
    },
    enabled: !!user && !!contractId,
  });

  return query;
};
